import { render, staticRenderFns } from "./Properties.vue?vue&type=template&id=3d758efc&scoped=true"
import script from "./Properties.vue?vue&type=script&lang=js"
export * from "./Properties.vue?vue&type=script&lang=js"
import style0 from "./Properties.vue?vue&type=style&index=0&id=3d758efc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d758efc",
  null
  
)

export default component.exports